<script>

import currencies from 'top20common/distribution/services/currencies';
import {mapGetters} from 'vuex';

import ReferralLinkContainer from '@/common/referral-link/ReferralLinkContainer';

export default {
  extends: ReferralLinkContainer,
  computed: {
    ...mapGetters([
      'referralInviteState',
      'jobDetailsState',
      'userDetailsState',
      'isLoggedIn',
      'minPotentialBonusState',
      'maxPotentialBonusState',
      'potentialBonusCurrencyState'
    ]),
    referLink() {
      return `${this.host}/refer/${this.profileDetailsState.referral_code}/${this.jobDetailsState.code}`;
    },
    inviteData() {
      return {
        ...this.referralInviteState,
        job_code: this.jobDetailsState.code
      };
    },
    amount() {
      if (this.jobDetailsState && this.isLoggedIn) {
        return currencies.getSimplifiedMoneyRange(
          this.jobDetailsState.min_hired_reward,
          this.jobDetailsState.max_hired_reward,
          this.userDetailsState.currency
        );
      }

      return currencies.getSimplifiedMoneyRange(
        this.minPotentialBonusState,
        this.maxPotentialBonusState,
        this.potentialBonusCurrencyState
      );
    },
    referralLinkLabel() {
      return this.$gettext('A successful referral for this position can earn up to:');
    }
  }
};
</script>
